module.exports = __webpack_public_path__ + "static/media/image11.32f9d865.jpg";